"use strict";

document.addEventListener("DOMContentLoaded", () => {
  /********************************
   * Vars
   *******************************/
  const html = document.querySelector("html");
  const body = document.querySelector("body");
  const screenWidth = window.innerWidth;

  /********************************
   * Accordion: FAQ
   *******************************/
  const accordionGroup = document.querySelectorAll(".accordion-wrap");

  if (accordionGroup.length >= 1) {
    accordionGroup.forEach((accordion) => {
      const isAccordionDisabled = () => {
        const width = window.innerWidth;
        if (width < 992 && accordion.classList.contains("show-all-on-mobile")) {
          return true;
        }

        if (width > 992 && accordion.classList.contains("accordion-mobile-only")) {
          return true;
        }

        return false;
      };

      if (accordion.classList.contains("open-first-child")) {
        setTimeout(() => {
          if (isAccordionDisabled()) return;

          const accordionItem = accordion.querySelector(".accordion-item");
          if (!accordionItem) return;

          const customPadding = +accordionItem.dataset.descriptionPadding || 24;
          const accordionContent = accordionItem.querySelector(
              ".accordion-description",
          );

          accordionItem.classList.add("active");
          accordionContent.style.height =
              accordionItem.querySelector(".accordion-inner-content")
                  .scrollHeight +
              customPadding +
              "px";
        }, 1300);
      }

      if (accordion.classList.contains("open-all-child")) {
        setTimeout(() => {
          const accordionItems = accordion.querySelectorAll(".accordion-item");
          accordionItems.forEach((accordionItem) => {
            const customPadding =
                +accordionItem.dataset.descriptionPadding || 24;
            const accordionContent = accordionItem.querySelector(
                ".accordion-description",
            );

            accordionItem.classList.add("active");
            accordionContent.style.height =
                accordionContent.querySelector(".accordion-inner-content")
                    .scrollHeight +
                customPadding +
                "px";
          });
        }, 1300);
      }

      accordion.addEventListener("click", function ({ target }) {
        if (isAccordionDisabled()) {
          return;
        }

        const accordionItem = target.closest(".accordion-item");
        if (!accordionItem || target.closest(".accordion-description")) {
          return;
        }

        const customPadding = +accordionItem.dataset.descriptionPadding || 24;
        const accordionContent = accordionItem.querySelector(".accordion-description",);

        if (accordionItem.classList.contains("active")) {
          accordionItem.classList.remove("active");
          accordionContent.style.height = 0 + "px";
        } else {
          accordionItem.classList.add("active");
          accordionContent.style.height =
              accordionContent.querySelector(".accordion-inner-content").scrollHeight + customPadding + "px";
        }
      });
    });
  }

  /********************************
   * Section: Banner with timer
   *******************************/
  const bannerWithTimer = document.querySelectorAll(".banner-with-timer");

  if (bannerWithTimer.length >= 1) {
    bannerWithTimer.forEach(section => {
      const countdownEl = section.querySelector('banner-countdown');

      const endDate = countdownEl.dataset.endDate;
      const display = countdownEl.querySelector('[data-time-display]');
      const daysEl = countdownEl.querySelector('[data-days]');
      const hoursEl = countdownEl.querySelector('[data-hours]');
      const minutesEl = countdownEl.querySelector('[data-minutes]');
      const secondsEl = countdownEl.querySelector('[data-seconds]');

      if (!endDate || !display) return;

      const target = Date.parse(endDate);
      if (Number.isNaN(target)) return;

      let intervalId = null;

      const setUnit = (el, value) => {
        if (!el) return;
        el.textContent = String(value).padStart(2, '0');
      };

      const tick = () => {
        const diff = target - Date.now();

        if (diff > 0) {
          const days = Math.floor(diff / (1000 * 60 * 60 * 24));
          const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
          const minutes = Math.floor((diff / 1000 / 60) % 60);
          const seconds = Math.floor((diff / 1000) % 60);

          setUnit(daysEl, days);
          setUnit(hoursEl, hours);
          setUnit(minutesEl, minutes);
          setUnit(secondsEl, seconds);

          display.classList.add('countdown-display--loaded');
          return;
        }

        setUnit(daysEl, 0);
        setUnit(hoursEl, 0);
        setUnit(minutesEl, 0);
        setUnit(secondsEl, 0);

        if (intervalId) {
          window.clearInterval(intervalId);
        }
      };

      tick();
      intervalId = window.setInterval(tick, 1000);
    });
  }

  /********************************
   * Section: Single product
   *******************************/
  const singleProduct = document.querySelectorAll(".single-product");

  if (singleProduct.length >= 1) {
    const initializeUGC = (ugcSliderElement) => {
      if (!ugcSliderElement || ugcSliderElement.dataset.ugcInitialized === "1") return;
      ugcSliderElement.dataset.ugcInitialized = "1";

      const sectionElement = ugcSliderElement.closest(".single-product");
      if (!sectionElement) return;

      const popupElement = sectionElement.querySelector(".ugc-popup");
      const videoBoxElement = popupElement ? popupElement.querySelector(".video-box") : null;

      if (!popupElement || !videoBoxElement) return;

      const slideElements = Array.from(ugcSliderElement.querySelectorAll(".swiper-slide[data-ugc-item]"));
      const slideCount = slideElements.length;
      if (slideCount === 0) return;

      let currentIndex = 0;

      const stopAndClearPopupVideo = () => {
        const videoElement = videoBoxElement.querySelector("video");
        if (videoElement) {
          try {
            videoElement.pause();
          } catch (e) {}
        }
        videoBoxElement.innerHTML = "";
      };

      const openPopup = () => {
        popupElement.classList.add("show");
        popupElement.setAttribute("aria-hidden", "false");
      };

      const closePopup = () => {
        stopAndClearPopupVideo();
        popupElement.classList.remove("show");
        popupElement.setAttribute("aria-hidden", "true");
      };

      const renderAndPlayVideoByIndex = (index) => {
        const normalizedIndex = ((index % slideCount) + slideCount) % slideCount;
        currentIndex = normalizedIndex;

        const slideElement = slideElements[normalizedIndex];
        if (!slideElement) return;

        const videoUrl = slideElement.dataset.videoUrl;
        const posterUrl = slideElement.dataset.poster;

        stopAndClearPopupVideo();

        if (!videoUrl) return;

        const videoElement = document.createElement("video");
        videoElement.className = "ugc-popup-video";
        videoElement.playsInline = true;
        videoElement.preload = "metadata";
        videoElement.muted = false;
        videoElement.autoplay = true;
        videoElement.controls = true;

        if (posterUrl) videoElement.setAttribute("poster", posterUrl);

        const sourceElement = document.createElement("source");
        sourceElement.src = videoUrl;
        sourceElement.type = "video/mp4";

        videoElement.appendChild(sourceElement);
        videoBoxElement.appendChild(videoElement);

        const playPromise = videoElement.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {});
        }
      };

      const openPopupFromSlide = (slideElement) => {
        if (!slideElement) return;
        const indexAttr = slideElement.getAttribute("data-index");
        const index = indexAttr ? parseInt(indexAttr, 10) : slideElements.indexOf(slideElement);
        if (Number.isNaN(index) || index < 0) return;

        openPopup();
        renderAndPlayVideoByIndex(index);
      };

      const previousButton = popupElement.querySelector(".video-prev");
      const nextButton = popupElement.querySelector(".video-next");
      const closeButton = popupElement.querySelector(".popup-close");
      const popupOverflow = popupElement.querySelector(".ugc-popup-overflow");

      if (previousButton) {
        previousButton.addEventListener("click", (event) => {
          event.preventDefault();
          renderAndPlayVideoByIndex(currentIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener("click", (event) => {
          event.preventDefault();
          renderAndPlayVideoByIndex(currentIndex + 1);
        });
      }

      if (popupOverflow) {
        popupOverflow.addEventListener("click", (event) => {
          event.preventDefault();
          closePopup();
        });
      }

      if (closeButton) {
        closeButton.addEventListener("click", (event) => {
          event.preventDefault();
          closePopup();
        });
      }

      popupElement.addEventListener("click", (event) => {
        if (event.target === popupElement) closePopup();
      });

      if (slideCount > 2 && typeof Swiper !== 'undefined') {
        const ugcWrap = ugcSliderElement.closest(".ugc-wrap");
        if (ugcWrap) ugcWrap.classList.add("slider-active");

        new Swiper(ugcSliderElement, {
          slidesPerView: 2.15,
          spaceBetween: 15,
          threshold: 8,

          breakpoints: {
            768: {
              slidesPerView: 3.2
            }
          },

          on: {
            click(swiper, event) {
              const slideElement = event.target.closest(".swiper-slide[data-ugc-item]");
              if (slideElement) openPopupFromSlide(slideElement);
            },
          },
        });
      } else {
        ugcSliderElement.addEventListener("click", (event) => {
          const slideElement = event.target.closest(".swiper-slide[data-ugc-item]");
          if (slideElement) openPopupFromSlide(slideElement);
        });
      }
    };

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        document.querySelectorAll(".ugc-popup.show").forEach(popup => {
          popup.classList.remove("show");
          popup.setAttribute("aria-hidden", "true");
          const videoElement = popup.querySelector(".video-box video");
          if (videoElement) {
            try { videoElement.pause(); } catch (e) {}
          }
          const videoBox = popup.querySelector(".video-box");
          if (videoBox) videoBox.innerHTML = "";
        });
      }
    });

    singleProduct.forEach((section) => {

      /*************** Main slider ***************/
      const mainEl = section.querySelector(".slider_main_init");
      const thumbsEl = section.querySelector(".slider_thumbs_init");

      if (mainEl && thumbsEl && typeof Swiper !== 'undefined') {
        const slidesCount = mainEl.querySelectorAll(".swiper-slide").length;

        if (slidesCount > 1) {
          const productMedia = mainEl.closest(".product-media");
          if (productMedia) productMedia.classList.add("slider-init");

          const thumbsSwiper = new Swiper(thumbsEl, {
            spaceBetween: 10,
            slidesPerView: 7,
            hashNavigation: true,
            watchSlidesProgress: true,
            slideToClickedSlide: true,

            breakpoints: {
              768: {
                spaceBetween: 20,
                slidesPerView: 5,
              },
            }
          });

          new Swiper(mainEl, {
            spaceBetween: 20,
            slidesPerView: 1,
            thumbs: {
              swiper: thumbsSwiper,
            }
          });
        }
      }

      /*************** POPUP ***************/
      const closeAllPopups = () => {
        section.querySelectorAll(".info-popup").forEach((p) => {
          p.classList.remove("show");
          p.setAttribute("aria-hidden", "true");
        });
      };

      const openPopupByType = (type) => {
        if (!type) return;
        const popup = section.querySelector(`.info-popup.type-${type}`);
        if (!popup) return;

        closeAllPopups();
        popup.classList.add("show");
        popup.setAttribute("aria-hidden", "false");
      };

      section.addEventListener("click", (e) => {
        const trigger = e.target.closest(".popup-trigger");

        if (trigger) {
          const typeClass = [...trigger.classList].find((c) => c.startsWith("type-"));
          const type = typeClass?.replace("type-", "");
          openPopupByType(type);
          return;
        }

        if (e.target.closest(".popup-close") || e.target.closest(".popup-overflow")) {
          closeAllPopups();
          return;
        }

        const popup = e.target.closest(".info-popup");
        if (popup && e.target === popup) closeAllPopups();
      });

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") closeAllPopups();
      });

      /*************** Variant Buttons Slider (<= 991px) ***************/
      /*const variantSliderElement = section.querySelector(".variant-slider_init");

      if (variantSliderElement && typeof Swiper !== 'undefined') {
        const mediaQuery991 = window.matchMedia('(max-width: 991px)');
        let variantSwiperInstance = undefined;

        const handleVariantSlider = () => {
          if (mediaQuery991.matches) {
            if (variantSwiperInstance === undefined) {
              variantSwiperInstance = new Swiper(variantSliderElement, {
                slidesPerView: 'auto',
                spaceBetween: 8,
                freeMode: true,
                watchOverflow: true,
                grabCursor: true,
                nested: true,
                touchStartPreventDefault: false,


                observer: true,
                observeParents: true,
                updateOnWindowResize: true
              });
            }
          } else {
            if (variantSwiperInstance !== undefined) {
              variantSwiperInstance.destroy(true, true);
              variantSwiperInstance = undefined;
            }
          }
        };

        handleVariantSlider();
        mediaQuery991.addEventListener('change', handleVariantSlider);
      }*/

      /*************** Sticky Product ***************/
      const stickyEl = document.querySelector('.sticky-product');
      const buyButtonsEl = section.querySelector('.product-block-buy-buttons');

      if (stickyEl && buyButtonsEl) {
        const stickyObserver = new IntersectionObserver(
          ([entry]) => {
            const isButtonsScrolledUp = !entry.isIntersecting && entry.boundingClientRect.top < 0;

            if (isButtonsScrolledUp) {
              stickyEl.classList.add('show');
            } else {
              stickyEl.classList.remove('show');
            }
          },
          {
            threshold: 0,
            rootMargin: "0px 0px 0px 0px"
          }
        );

        stickyObserver.observe(buyButtonsEl);
      }

      /*************** UGC ***************/
      const ugcSliderElement = section.querySelector(".ugc_init");

      if (ugcSliderElement) {
        initializeUGC(ugcSliderElement);
      }

      /*************** slider_reviews ***************/
      const reviewsSlider = section.querySelector('.slider-reviews-init');

      if (reviewsSlider) {
        const hasSlides = section.querySelectorAll('.slider-reviews-init .swiper-slide').length > 1;

        if (hasSlides && typeof Swiper !== 'undefined') {
          const reviewsInner = reviewsSlider.closest('.slider-reviews-inner');
          if (reviewsInner) reviewsInner.classList.add('init');

          new Swiper(reviewsSlider, {
            slidesPerView: 1.03,
            spaceBetween: 12,

            breakpoints: {
              768: {
                spaceBetween: 15,
                slidesPerView: 1.1
              }
            },
          });
        }
      }

      /*************** Buy Now button -> add to cart + straight to checkout ***************/
      // Adds the selected item ON TOP of whatever is already in the cart (the
      // original version cleared the cart first — never do that again), then
      // redirects to /checkout. The real submit button stays hidden by the
      // .button-checkout CSS; this one fronts for it.
      const checkoutBtn = section.querySelector('.add-to-checkout-btn');
      const productForm = section.querySelector('[data-product-form]');

      if (checkoutBtn && productForm) {
        const addToCartBtn = section.querySelector('.add-to-cart-btn');

        const syncCheckoutBtnState = () => {
          if (!addToCartBtn) return;
          checkoutBtn.disabled = addToCartBtn.disabled;
          checkoutBtn.classList.toggle('cursor-not-allowed', addToCartBtn.disabled);
        };

        syncCheckoutBtnState();
        section.addEventListener('shapes:product:variantchange', syncCheckoutBtnState);

        if (addToCartBtn) {
          new MutationObserver(syncCheckoutBtnState).observe(addToCartBtn, {
            attributes: true,
            attributeFilter: ['disabled'],
          });
        }

        checkoutBtn.addEventListener('click', async (event) => {
          event.preventDefault();

          if (checkoutBtn.disabled) return;

          const sellingPlanSelector = section.querySelector('selling-plan-selector');
          if (sellingPlanSelector && typeof sellingPlanSelector.onSellingPlanChange === 'function') {
            sellingPlanSelector.onSellingPlanChange();
          }

          const variantSelect = productForm.querySelector('[name="id"]');
          if (!variantSelect?.value) return;

          const selectedOption = variantSelect.options[variantSelect.selectedIndex];
          if (selectedOption?.disabled) return;

          checkoutBtn.disabled = true;
          const checkoutBtnLabel = checkoutBtn.querySelector('.push-btn-surface');
          const originalLabel = checkoutBtnLabel?.textContent;
          if (checkoutBtnLabel) {
            checkoutBtnLabel.textContent = window.theme?.strings?.loading || 'Loading...';
          }

          try {
            const config = fetchConfigDefaults('javascript');
            config.body = new FormData(productForm);
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const response = await fetch(window.theme.routes.cart_add_url, config);
            const data = await response.json();

            if (data.status) {
              const message = data.description || data.message || window.theme.strings.cartError;
              const alpineSection = section.closest('[data-product-section]') || section;

              if (window.Alpine && typeof Alpine.$data === 'function') {
                const alpineData = Alpine.$data(alpineSection);
                if (alpineData) alpineData.cartAddErrorMessage = message;
              }

              document.body.dispatchEvent(
                new CustomEvent('shapes:cart:adderror', {
                  detail: {
                    source: 'checkout-button',
                    sourceId: productForm.id,
                    variantId: config.body.get('id'),
                    errors: data.errors || data.description,
                    message,
                  },
                })
              );
              return;
            }

            const rootUrl = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
            window.location.assign(`${rootUrl}checkout`);
          } catch (error) {
            console.error(error);
          } finally {
            syncCheckoutBtnState();
            if (checkoutBtnLabel && originalLabel) {
              checkoutBtnLabel.textContent = originalLabel;
            }
          }
        });
      }
    });
  }

  /********************************
   * Subscribe Info POPUP
   *******************************/
  const subscribeInfoPopup = document.querySelector('.subscribe-info-popup');
  const subscribePopupTrigger = document.querySelector('.subscription-popup-trigger');

  if (subscribeInfoPopup && subscribePopupTrigger) {
    const popupClose = subscribeInfoPopup.querySelector('.close');
    const popupOverflow = subscribeInfoPopup.querySelector('.overflow');

    popupClose.addEventListener('click', () => subscribeInfoPopup.classList.remove('show'));
    popupOverflow.addEventListener('click', () => subscribeInfoPopup.classList.remove('show'));
    subscribePopupTrigger.addEventListener('click', () => subscribeInfoPopup.classList.toggle('show'));
  }

  /********************************
   * Section: Logo Ticker
   *******************************/
  const logoTickerSection = document.querySelectorAll(".logo-ticker-section");

  if(logoTickerSection.length) {
    function startSlider(sliderInit) {

      new Swiper(sliderInit, {
        slidesPerView: 'auto',
        allowTouchMove: false,
        loop: true,
        speed: 6000,
        freeMode: true,
        freeModeMomentum: false,

        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },

        observer: true,
        observeParents: true
      });
    }

    logoTickerSection.forEach((section) => {
      startSlider(section.querySelector(".logo-ticker-swiper"));
    });
  }

  /********************************
   * Section: Section Reviews
   *******************************/
  const sectionReviews = document.querySelectorAll(".section-reviews");

  if(sectionReviews.length) {
    function initializeSlider(slider, slideCount) {
      if (screenWidth >= 992 && slideCount > 3) {
        startSlider(slider);
      } else if (screenWidth >= 768 && screenWidth <= 991 && slideCount > 2) {
        startSlider(slider);
      } else if (screenWidth <= 767 && slideCount > 1) {
        startSlider(slider);
      }
    }

    function startSlider(sliderInit) {
      sliderInit.closest('.swiper-slider-wrap').classList.add('init');

      new Swiper(sliderInit, {
        spaceBetween: 15,
        slidesPerView: 1.12,
        centeredSlides: true,

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },

        navigation: {
          nextEl: ".slider-next",
          prevEl: ".slider-prev",
        },

        breakpoints: {
          768: {
            slidesPerView: 2.1,
            centeredSlides: false,
          },

          992: {
            slidesPerView: 3,
            centeredSlides: false,
          }
        }
      });
    }

    sectionReviews.forEach((section) => {
      const slider = section.querySelector('.swiper-slider-reviews');
      const slideCount = section.querySelectorAll('.swiper-slide').length;

      initializeSlider(slider, slideCount)
    });
  }

  /********************************
   * Section: Product Delivery Scheduler
   *******************************/
  const productDeliverySchedulers = document.querySelectorAll(".product-delivery-scheduler");

  if (productDeliverySchedulers.length >= 1) {
    productDeliverySchedulers.forEach(section => {
      const zipInput = section.querySelector("#delivery-zip-code");
      const dateTrigger = section.querySelector("#delivery-date-trigger");
      const modal = section.querySelector("#delivery-modal");
      const zipError = section.querySelector('.delivery-scheduler-error');

      // main-product templates wrap the form in .main-product; the
      // single-page-product templates (signature 8/10) expose it via
      // [data-product-form] instead
      const mainProductForm = document.querySelector('.main-product .product-block-buy-buttons form')
        || document.querySelector('.single-product form[data-product-form]');

      if (!zipInput || !dateTrigger || !modal || !mainProductForm) {
        section.classList.add('hidden');
        return;
      }

      // Delivery date is stored in TWO places, kept in sync (one date per order, last confirm wins):
      // 1. An order-level CART ATTRIBUTE - ShipStation imports it via the
      //    "Shopify Order Note Attributes" -> Custom Field mapping / the Flow order-tag workflow.
      // 2. A visible LINE ITEM PROPERTY on each scheduler product (hidden input injected into the
      //    product form at confirm time, plus a cart/change.js sync of lines already in the cart),
      //    so the date renders under the product in the cart drawer, checkout, and order emails.
      const confirmBtn = modal.querySelector("#delivery-confirm-btn");
      const earliestDateText = modal.querySelector("#earliest-date-text");
      const calendarEl = modal.querySelector("#inline-calendar");

      let selectedDateInstance = null;
      // The zip-computed set of bookable delivery dates (YYYY-MM-DD). Empty until a
      // valid zip is entered; confirm refuses any selection outside this list.
      let enabledDates = [];

      // No onReady auto-select here: at page load the calendar is unrestricted
      // (no zip yet), so auto-clicking would store "today" as the selection and
      // it could get submitted as-is. The first valid day is auto-selected in
      // openModal instead, after the zip has narrowed the calendar.
      const picker = flatpickr(calendarEl, {
        inline: true,
        minDate: "today",
        disable: deliverScheduelerConf.holidays,
        onChange: function(selectedDates, dateStr, instance) {
          if (selectedDates.length > 0) {
            selectedDateInstance = selectedDates[0];
            if (earliestDateText) {
              const formatted = instance.formatDate(selectedDates[0], "M j");
              earliestDateText.textContent = formatted.toLowerCase();
            }
          } else {
            selectedDateInstance = null;
          }
        }
      });

      zipInput.addEventListener('keyup',function () {
        dateTrigger.value = "";
        dateTrigger.closest('.delivery-date-wrapper').classList.remove('valid');
        zipInput.classList.remove('is-error');
        zipError.classList.add('hidden');
        if (zipInput.value.length < 5) {
          zipInput.classList.add('is-error');
          zipError.textContent = 'please enter a valid 5-digit zip code.';
          zipError.classList.remove('hidden');
          return;
        }
        let maxDays = 90;
        let zipPre = zipInput.value.slice(0,3);
        let zone = deliverySchedulerZones.prefixToZone[zipPre];

        // Unsupported destinations: HI/AK/PR (no UPS Ground from York, PA) or unrecognized prefixes.
        if (zone === undefined) {
          zipInput.classList.add('is-error');
          zipError.textContent = deliverySchedulerZones.unsupported && deliverySchedulerZones.unsupported[zipPre]
            ? "sorry — we can't ship fresh pretzels to hawaii, alaska, or puerto rico (no ups ground service)."
            : "hmm, we don't recognize that zip code — double-check it?";
          zipError.classList.remove('hidden');
          return;
        }

        dateTrigger.closest('.delivery-date-wrapper').classList.add('valid');

        let shipDays = [];
        let transitDays = 0;
        let airService = false;
        for (const [key, zoneGroup] of Object.entries(deliverScheduelerConf.zoneGroups)) {
          if (zoneGroup.zones.includes(zone)) {
            shipDays = zoneGroup.shipDays;
            transitDays = zoneGroup.transitDays;
            airService = zoneGroup.air === true;
          }
        }
        // Fix #1: ship days are bakery DEPARTURE days; deliveryWeekdays applies to ARRIVAL dates only.
        let ships = shipDays;

        let holidays = deliverScheduelerConf.holidays;
        let deliveryWeekdays = deliverScheduelerConf.deliveryWeekdays;
        // Departure-only blackouts (pickup closed, UPS still delivering) and
        // air-only delivery dates — see notes in delivery-config.liquid.
        let noShipDates = deliverScheduelerConf.noShipDates || [];
        let noGroundDeliveryDates = deliverScheduelerConf.noGroundDeliveryDates || [];
        let emergencyDays = Number(deliverScheduelerConf.emergency[zone] || 0);
        let toYMD = (d) => d.toISOString().split('T')[0];
        let mondayOf = (d) => { let m = new Date(d); m.setDate(m.getDate() - ((m.getDay() + 6) % 7)); return m; };

        // Fix #4b: transit counts only weekdays that are not holidays,
        // so a holiday during transit pushes delivery forward one day per holiday.
        let computeDelivery = (shipDate) => {
          let d = new Date(shipDate);
          let counted = 0;
          while (counted < transitDays) {
            d.setDate(d.getDate() + 1);
            let wd = d.getDay();
            if (wd >= 1 && wd <= 5 && !holidays.includes(toYMD(d))) counted++;
          }
          return d;
        };

        // Fix #4a: a valid ship day is scheduled for the zone, is NOT a bakery holiday,
        // and its delivery lands Tue-Fri of the SAME week (a box is never in transit over a weekend).
        let isValidShipDay = (d) => {
          if (!ships.includes(d.getDay())) return false;
          if (holidays.includes(toYMD(d))) return false;
          if (noShipDates.includes(toYMD(d))) return false;
          let del = computeDelivery(d);
          if (!deliveryWeekdays.includes(del.getDay())) return false;
          if (toYMD(mondayOf(del)) !== toYMD(mondayOf(d))) return false;
          if (!airService && noGroundDeliveryDates.includes(toYMD(del))) return false;
          return true;
        };

        let dates = [];
        let currentDate = new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));
        currentDate.setDate(currentDate.getDate() + 1); // midnight cut-off: an order never ships same day

        // Peak: promise the FOLLOWING week's ship slot. Find the normal slot first, then restart
        // the scan from the Monday of the week after it (a flat +7 on the start date is not equivalent).
        if (deliverScheduelerConf.peak) {
          let probe = new Date(currentDate);
          for (let k = 0; k < maxDays; k++) {
            if (isValidShipDay(probe)) break;
            probe.setDate(probe.getDate() + 1);
          }
          currentDate = mondayOf(probe);
          currentDate.setDate(currentDate.getDate() + 7);
        }

        let i = 0;
        let firstDate = '';
        while (i < maxDays) {
          if (isValidShipDay(currentDate)) {
            let deliveryDate = computeDelivery(currentDate);

            // Fix #3: emergency delay pushes the DELIVERY date by N calendar days,
            // then snaps forward to the next valid delivery day (Tue-Fri, non-holiday).
            if (emergencyDays > 0) {
              deliveryDate.setDate(deliveryDate.getDate() + emergencyDays);
              while (!deliveryWeekdays.includes(deliveryDate.getDay()) || holidays.includes(toYMD(deliveryDate)) || (!airService && noGroundDeliveryDates.includes(toYMD(deliveryDate)))) {
                deliveryDate.setDate(deliveryDate.getDate() + 1);
              }
            }

            if (firstDate === '') {
              firstDate = new Intl.DateTimeFormat('en-US', {
                month: 'short',
                day: 'numeric'
              }).format(deliveryDate);
            }
            if (!dates.includes(toYMD(deliveryDate))) dates.push(toYMD(deliveryDate));
          }

          currentDate.setDate(currentDate.getDate() + 1);
          i++;
        }
        earliestDateText.innerHTML = firstDate;
        enabledDates = dates;
        // A selection made under the previous zip (or the unrestricted pre-zip
        // calendar) may not be valid for this zone — drop it so openModal
        // re-selects the first valid day.
        picker.clear();
        selectedDateInstance = null;
        picker.set("enable", dates);
      });

      const openModal = (e) => {
        e.stopPropagation();
        if (!dateTrigger.closest('.delivery-date-wrapper').classList.contains('valid')) return;
        modal.classList.add("is-active");
        picker.redraw();

        window.setTimeout(() => {
          if (!selectedDateInstance) {
            const firstActiveDay = modal.querySelector('.flatpickr-day:not(.flatpickr-disabled)');
            if (firstActiveDay) firstActiveDay.click();
          }
        }, 50);
      };

      const closeModal = () => {
        modal.classList.remove("is-active");
      };

      dateTrigger.addEventListener("click", openModal);

      modal.addEventListener("click", (e) => {
        e.stopPropagation();
      });

      document.addEventListener("click", closeModal);

      if (confirmBtn) {
        confirmBtn.addEventListener("click", async function(e) {
          e.stopPropagation();
          if (selectedDateInstance) {
            const year = selectedDateInstance.getFullYear();
            const month = String(selectedDateInstance.getMonth() + 1).padStart(2, '0');
            const day = String(selectedDateInstance.getDate()).padStart(2, '0');

            // Never submit a date outside the zip-computed valid set (stale
            // pre-zip selection, or a leftover from a previous zip). Re-snap to
            // the earliest valid date and keep the modal open so the customer
            // sees the corrected selection before confirming.
            if (!enabledDates.includes(`${year}-${month}-${day}`)) {
              if (enabledDates.length > 0) picker.setDate(enabledDates[0], true);
              return;
            }

            const formattedDate = `${month}/${day}/${year}`;
            dateTrigger.value = formattedDate;

            // Line item property: a hidden input in the product form, so every add-to-cart
            // stamps the line with the date. Injected only after a date is confirmed -
            // adding it to the markup up front would submit an empty property.
            let hiddenDateInput = mainProductForm.querySelector('input[name="properties[Delivery date]"]');
            if (!hiddenDateInput) {
              hiddenDateInput = document.createElement('input');
              hiddenDateInput.type = 'hidden';
              hiddenDateInput.name = 'properties[Delivery date]';
              mainProductForm.appendChild(hiddenDateInput);
            }
            hiddenDateInput.value = formattedDate;

            // Save the delivery date as an order-level cart attribute.
            // Each confirm overwrites the previous value (one date per order, last confirm wins).
            // Note: Shopify's cart clear (used by the express checkout button) preserves attributes.
            const rootUrl = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
            try {
              await fetch(`${rootUrl}cart/update.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: { 'Delivery date': formattedDate } })
              });

              // Sync dated lines already in the cart to the newly confirmed date, so the
              // per-line dates never contradict the order-level attribute (one shipment,
              // one date per order). Sequential on purpose: concurrent cart mutations race.
              const cart = await (await fetch(`${rootUrl}cart.js`)).json();
              for (const item of cart.items) {
                const props = item.properties || {};
                if (props['Delivery date'] && props['Delivery date'] !== formattedDate) {
                  await fetch(`${rootUrl}cart/change.js`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      id: item.key,
                      quantity: item.quantity,
                      properties: Object.assign({}, props, { 'Delivery date': formattedDate })
                    })
                  });
                }
              }
            } catch (error) {
              console.error('Could not save delivery date to cart:', error);
            }
          }
          closeModal();
        });
      }
    });
  }
});